module.exports = __webpack_public_path__ + "svg/new-discover-small.dbe89273f777f87a7463380b0a351208.svg";